import { Spinner } from "@radix-ui/themes";
import formatPrice from "@/core/helpers/formatPrice";
import { imgSbankSbankOnboardingBgFull02 } from "@/shared/assets/img";
import { CashIcon, CheckIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";
import { BankBullet } from "@/domains/bank/components/BankBullet/BankBullet";
import { OnboardingFrame } from "@/domains/bank/components/Onboarding/OnboardingFrame";

export function OnboardingStep03({
  onSubmit,
  onCancel,
  tariffName,
  tariffPrice,
  isLoading,
}: {
  onSubmit: () => void;
  onCancel: () => void;
  tariffName: string;
  tariffPrice: number;
  isLoading: boolean;
}) {
  return (
    <OnboardingFrame style={{ backgroundImage: `url(${imgSbankSbankOnboardingBgFull02})` }}>
      <div className="flex flex-col w-[60%] h-full justify-between mt-10">
        {/* Welcome text */}
        <div className="flex flex-col gap-3">
          <h3 className="text-20 font-bold text-sbank">Счет почти открыт!</h3>

          <p className="font-normal leading-tight">
            Остался всего один шаг и вы станете клиентом нашего
            <br />
            банка. Пожалуйста, ознакомьтесь с реквизитами вашего
            <br />
            счета.
          </p>
        </div>

        {/* Benefits */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4 mb-4">
            <BankBullet>
              <CheckIcon className="size-4 text-dark-900" />
            </BankBullet>

            <div className="flex flex-col gap-2 justify-center">
              <div className="text-14 font-bold leading-none text-white uppercase">
                {tariffName}
              </div>
              <div className="text-15 leading-none text-white/50">Тарифный план</div>
            </div>
          </div>

          <hr className="w-1/2 border-white/5" />

          {/* Account number */}
          <div className="flex items-center gap-4 mb-4">
            <div className="size-[36px] flex items-center justify-center">
              <CashIcon className="size-6 text-sbank" />
            </div>

            <div className="flex gap-2">
              <div className="text-15 leading-none text-sbank">Стоимость открытия:</div>
              <div className="text-16 font-medium tabular-nums leading-none">
                {formatPrice(tariffPrice)} ₽
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <Button
              variant="solid-gradient"
              data-mz-accent="success"
              className="w-[160px]"
              onClick={onSubmit}
              disabled={isLoading}
            >
              {isLoading ? <Spinner className="size-5" /> : "Подтвердить"}
            </Button>

            <Button
              variant="solid-outline"
              data-mz-accent="success"
              className="w-[120px] bg-[#21a0381a] text-sbank border-none hover:bg-[#21a0381a]/12"
              onClick={onCancel}
            >
              Назад
            </Button>
          </div>
        </div>
      </div>
    </OnboardingFrame>
  );
}
